import { useAdNetworks } from "../hooks/useData";
import SelectWithIcons from "./select-icon";

const SelectAdnetworkComponent = (props) => {
  const { adNetworks, loading, error } = useAdNetworks();

  if (loading) {
    return (
      <SelectWithIcons
        options={[]}
        value={props.value}
        onChange={props.onChange}
        default="Loading..."
        className={props.className}
        disabled
      />
    );
  }

  if (error) {
    return (
      <SelectWithIcons
        options={[]}
        value={props.value}
        onChange={props.onChange}
        default="Error loading ad networks"
        className={props.className}
        disabled
      />
    );
  }

  return (
    <SelectWithIcons
      options={adNetworks}
      value={props.value}
      onChange={props.onChange}
      default={props.default || "All AdNetwork"}
      className={props.className}
    />
  );
};

export default SelectAdnetworkComponent;